import { render, staticRenderFns } from "./ProjectConfig.vue?vue&type=template&id=e8c1f33c&"
import script from "./ProjectConfig.vue?vue&type=script&lang=js&"
export * from "./ProjectConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports